<template>
  <v-container class="fill-height" style="display: block;" fluid>
    <v-window v-model="windowPage" style="width: 100%; height: 100%;" touchless>

        <v-window-item :key="0">
            <div id="ag-grid-container">
                <ag-grid-vue style="width: 100%; height: 100%;" class="ag-theme-balham" v-if="showGrid"
                    :gridOptions="gridOptions"
                    @row-double-clicked="(params) => editUserGroup(params.data)"
                    :groupHeaders="true"
                    :rowHeight="40">
                </ag-grid-vue>
            </div>
            <v-btn color="#c42111" class="mt-3 mr-3" @click="newUserGroup" :disabled="lockSave || !isCustomerAdmin" v-if="showGrid">New</v-btn>
            <div class="admin-page-grid-center-buttons-container" v-if="showGrid">
                <div class="admin-page-grid-center-buttons-container-label">
                    <span>Grid Display</span>
                </div>
                <v-tooltip top color="rgba(97, 97, 97, 1.0)">
                    <template v-slot:activator="{ on }">
                        <v-btn class="mr-3" fab dark x-small color="#c42111" @click="saveGridModifications" title="Save Grid Modifications" v-on="on">
                            <v-icon>mdi-content-save</v-icon>
                        </v-btn>
                    </template>
                    <span>Save Grid Modifications</span>
                </v-tooltip>
                <v-tooltip top color="rgba(97, 97, 97, 1.0)">
                    <template v-slot:activator="{ on }">
                        <v-btn class="" fab dark x-small color="#c42111" @click="clearGridModifications" title="Clear Grid Modifications" v-on="on">
                            <v-icon>mdi-layers-remove</v-icon>
                        </v-btn>
                    </template>
                    <span>Clear Grid Modifications</span>
                </v-tooltip>
            </div>
        </v-window-item>

        <v-window-item :key="1">
            <user-group-edit v-if="windowPage == 1" :userGroup="selectedUserGroup" :userGroupsList="userGroupsList" :userGroupsResources="userGroupsResources" :lockSave="lockSave" @save="saveUserGroup" @cancel="windowPage = 0"></user-group-edit>
        </v-window-item>
    
    </v-window>
  </v-container>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
import UserGroupEdit from "@/components/UserGroups/UserGroupEdit";
export default {
    name: 'UserGroups',
    props: [''],
    components: {
        'ag-grid-vue': AgGridVue,
        UserGroupEdit
    },
    data: () => ({
        showGrid: false,
        userGroupsResources: [],
        userGroupsList: [],
        windowPage: 0,
        lockSave: false,
        selectedUserGroup: null,
        gridOptions: null,
        gridModifications: null
    }),

    computed: {
        isCustomerAdmin: function() {
            return (this.$store.state.user.user_data.is_customer_admin);
        }
    },

    methods: {
        getUserGroupsList: function() {
            this.showGrid = false;
            let route = (TELSA.apiHost + "usergroups/list");
            TELSA.loading(true);
            return this.$http.get(route).then(response => {
                let result = response.body;
                console.log(result)
                this.userGroupsList = result.user_groups_list;
                this.userGroupsResources = {usersList: result.users_list, permissionsList: result.permissions_list};
            });
        },

        buildAgGrid: function() {
            this.showGrid = false;
            this.gridOptions = {};
            this.gridOptions.rowData = this.userGroupsList;
            this.gridOptions.columnDefs = this.createColumnDefs();
            let self = this;
            this.gridOptions.onGridReady = function(params) {
                self.gridOptions.api.hideOverlay();
                //self.gridOptions.columnApi.autoSizeColumns();
                self.gridOptions.api.sizeColumnsToFit();

                if(self.gridModifications) {
                    let gm = self.gridModifications;
                    if(gm.columnState) {
                        self.gridOptions.columnApi.setColumnState(gm.columnState);
                    }
                    if(gm.filterModel) {
                        self.gridOptions.api.setFilterModel(gm.filterModel);
                    }
                    if(gm.sortModel) {
                        self.gridOptions.api.setSortModel(gm.sortModel);
                    }
                }
            }

            this.gridOptions.getContextMenuItems = function() {
                return [
                    'copy',
                    'copyWithHeaders',
                    'paste',
                    'csvExport',
                    'excelExport',
                    {
                        name: 'AI Analyser',
                        disabled: !self.$store.state.batchConfig.webapp_openai,
                        action: function() {
                            self.$store.commit('setAiAnalyzerContext', 'userGroups');
                            self.$store.commit('setAiAnalyzerGridAPI', self.gridOptions.api);
                            self.$store.commit('setShowAIAnalyzer', true);
                        },
                        icon: `<i data-v-10101010101="" aria-hidden="true" class="v-icon notranslate mdi mdi-lightning-bolt theme--dark"></i>`
                    },
                ];
            };

            this.gridOptions.defaultColDef = {
                sortable: true,
                filter: true,
                resizable: true
            }
            this.showGrid = true;
        },

        createColumnDefs: function() {
            let columnDefs = [];
            const self = this;
            columnDefs = [
                { 
                    headerName: '', 
                    suppressSizeToFit: true,
                    width: 120, filter: 'text', cellStyle: {'padding-top': '5px', 'text-align': 'left', 'background-color': 'white', 'border-right': 'black solid 1px'},
                    cellRenderer: class {
                        init(params) {
                            this.params = params;
                            this.eGui = document.createElement('div');
                            this.eGui.innerHTML = `<span class="mdi mdi-pencil-circle user-group-action" style="cursor: pointer; color: #c42111; font-size: 20pt" />
                                <span class="mdi mdi-delete-circle user-group-action" style="cursor: ${(self.lockSave || !self.isCustomerAdmin) ? 'default' : 'pointer'}; color: ${(self.lockSave || !self.isCustomerAdmin) ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />
                                <span class="mdi mdi-content-copy user-group-action" style="cursor: ${(self.lockSave || !self.isCustomerAdmin) ? 'default' : 'pointer'}; color: ${(self.lockSave || !self.isCustomerAdmin) ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />`
                            
                            this.editButtonHandler = this.editButtonHandler.bind(this);
                            this.deleteButtonHandler = this.deleteButtonHandler.bind(this);
                            this.cloneButtonHandler = this.cloneButtonHandler.bind(this);

                            this.editButton = this.eGui.querySelectorAll('.user-group-action')[0];
                            this.deleteButton = this.eGui.querySelectorAll('.user-group-action')[1];
                            this.cloneButton = this.eGui.querySelectorAll('.user-group-action')[2];
                            this.editButton.addEventListener('click', this.editButtonHandler);
                            this.deleteButton.addEventListener('click', this.deleteButtonHandler);
                            this.cloneButton.addEventListener('click', this.cloneButtonHandler);
                        }
                        getGui() {
                            return this.eGui;
                        }
                        editButtonHandler(event) {
                            event.stopPropagation();
                            this.params.editFunction(this.params);
                        }
                        deleteButtonHandler(event) {
                            event.stopPropagation();
                            this.params.deleteFunction(this.params);
                        }
                        cloneButtonHandler(event) {
                            event.stopPropagation();
                            this.params.cloneFunction(this.params);
                        }
                        destroy() {
                            this.editButton.removeEventListener('click', this.editButtonHandler);
                            this.deleteButton.removeEventListener('click', this.deleteButtonHandler);
                            this.cloneButton.removeEventListener('click', this.cloneButtonHandler);
                        }
                    },
                    cellRendererParams: {
                        editFunction: (params) => {
                            this.editUserGroup(params.data);
                        },
                        deleteFunction: (params) => {
                            if(!self.lockSave && self.isCustomerAdmin) {
                                this.deleteUserGroupClick(params.data);
                            }
                        },
                        cloneFunction: (params) => {
                            if(!self.lockSave && self.isCustomerAdmin) {
                                this.cloneUserGroupClick(JSON.parse(JSON.stringify(params.data)));
                            }
                        }
                    }
                },
                { 
                    headerName: 'Group Name', 
                    field: 'group_name', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Member Count', 
                    width: 250, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        return params.data.group_members.length;
                    }
                },
            ];
            return columnDefs;
        },

        editUserGroup: function(userGroup) {
            TELSA.loading(true);
            let route = (TELSA.apiHost + "usergroups/permissions");
            this.$http.post(route, {args: {userGroup: userGroup}}).then(response => {
                let result = response.body;
                let userGroupClone = JSON.parse(JSON.stringify(userGroup));
                userGroupClone.permissions = result;
                this.selectedUserGroup = userGroupClone;
                this.windowPage = 1;
                TELSA.loading(false);
            });
        },

        saveUserGroup: function(userGroup) {
            TELSA.loading(true);
            let route = (TELSA.apiHost + "usergroups/edit");
            if(userGroup.group_id == 0) {
                route = (TELSA.apiHost + "usergroups/add");
            }
            this.$http.post(route, {args: {userGroup: userGroup}}).then(response => {
                let result = response.body;
                this.$store.commit('setIsDirty', false);
                this.windowPage = 0;
                Promise.all(this.getPageData()).then(r => {TELSA.loading(false); this.buildAgGrid()});
            });
        },

        deleteUserGroupClick: function(userGroup) {
            this.$store.commit('showConfirmModal', {
                title: 'Delete User Group',
                message: `This operation will delete this user's login/password and all of their configuration information stored on the server. Are you sure you want to do this?`,
                type: 'delete',
                hideCancel: false,
                confirmAction: () => this.deleteUserGroup(userGroup)
            });
        },

        deleteUserGroup: function(userGroup) {
            TELSA.loading(true);
            let route = (TELSA.apiHost + "usergroups/delete");
            this.$http.post(route, {args: {userGroup: userGroup}}).then(response => {
                let result = response.body;
                Promise.all(this.getPageData()).then(r => {TELSA.loading(false); this.buildAgGrid()});
            });
        },

        newUserGroup: function() {
            this.selectedUserGroup = {
                permissions: [],
                group_id: 0,
                group_manager: 0,
                group_members: [],
                group_name:""
            };
            this.windowPage = 1;
        },

        cloneUserGroupClick: function(groupClone) {
            TELSA.loading(true);
            let route = (TELSA.apiHost + "usergroups/permissions");
            this.$http.post(route, {args: {userGroup: groupClone}}).then(response => {
                let result = response.body;
                this.selectedUserGroup = {
                    permissions: result,
                    group_id: 0,
                    group_manager: groupClone.group_manager,
                    group_members: groupClone.group_members,
                    group_name: groupClone.group_name
                };
                this.windowPage = 1;
                TELSA.loading(false);
            });
        },

        saveGridModifications: function () {
            TELSA.loading(true);
            let gridState = {
                columnState: this.gridOptions.columnApi.getColumnState(),
                filterModel: this.gridOptions.api.getFilterModel(),
                sortModel: this.gridOptions.api.getSortModel(),
            }
            this.$store.dispatch('setConfigItem', {key: 'user_groups_grid_state', value: JSON.stringify(gridState)}).then(response => {
                let result = response.body;
                TELSA.loading(false);
            });
        },

        clearGridModifications: function () {
            let colStates = this.gridOptions.columnApi.getColumnState();
            colStates.forEach(c => c.hide = false);
            this.gridOptions.columnApi.setColumnState(colStates);
            this.gridOptions.api.setFilterModel(null);
            this.gridOptions.api.setSortModel(null);
            this.$store.dispatch('setConfigItem', {key: 'user_groups_grid_state', value: ""}).then(response => { });
        },

        getGridModifications: function () {
            return this.$store.dispatch('getConfigItem', {key: 'user_groups_grid_state'}).then(response => {
                let result = response.body;
                this.gridModifications = result ? JSON.parse(result) : null;
            });
        },

        getPageData: function() {
            let promises = [];
            promises.push(this.getUserGroupsList());
            promises.push(this.getGridModifications());
            return promises;
        }
    },

    mounted() {
        // Permissions Check
        let permission = TELSA.checkPermission(this.$store.state.user, 'admin/group/edit-members');
        if(!permission) {
            let self = this;
            this.$store.commit('insufficientPermissions', {
                confirmAction: function(){Promise.all(self.getPageData()).then(r => {self.buildAgGrid(); TELSA.loading(false);})}
            });
            this.lockSave = true;
            return;
        }

        let promises = [];
        let lockName = `edit_groups`;
        let lockOwner = null;
        promises.push(this.$store.dispatch('getLock', lockName).then(l => {lockOwner = l}));
        promises = promises.concat(this.getPageData());
        Promise.all(promises).then(v => {
            this.buildAgGrid();
            TELSA.loading(false);
            if(lockOwner) {
                // Disable save and let user know page is locked!
                this.lockSave = true;
                this.$store.commit('showConfirmModal', {
                    title: 'Lock Warning',
                    message: `The user groups list is already locked for editing by <font color="#FB8C00"><b>${lockOwner}</b></font>. You cannot save any changes at this time.`,
                    type: 'warning',
                    hideCancel: true,
                    confirmAction: function(){}
                });
            }
        });
    }

  
};
</script>

<style scoped>
    .data-container {
        display: block;
        padding: 0;
    }
</style>

<style scoped>

    #ag-grid-container {
        height: calc(100vh - 126px);
        width: 100%;
    }

</style>
